/**
 * 百纳秒转时码
 */
Vue.filter("l100Ns2Tc$1", function (ns) {
  if (!ns && ns != 0) {
      return "00:00:00";
  } else {
      return TimeCodeConvert.l100Ns2Tc$1(ns).split(':').slice(0,-1).join(':');
  }
});